class StringMemory {
  private readonly storage: Storage;

  private readonly prefix: string;

  constructor(storage: Storage) {
    this.storage = storage;
    this.prefix = 'memory';
  }

  async get(key: string, callback: CallableFunction, ...args: any) {
    if (this.storage.getItem(this.getKeyName(key))) {
      return this.storage.getItem(this.getKeyName(key));
    }

    const result = await callback(...args);

    if (typeof result === 'string') {
      this.storage.setItem(this.getKeyName(key), result);
    } else {
      // eslint-disable-next-line no-console
      console.warn('Response of callback must of type string to be stored. Result was not stored');
    }

    return result;
  }

  delete(key: string) {
    this.storage.removeItem(this.getKeyName(key));
  }

  private getKeyName(key) {
    return `${this.prefix}-${key}`;
  }
}

export default (storage: Storage) => new StringMemory(storage);
